import { NaniumObject, RequestType, Type } from 'nanium/objects';
import { ServiceRequestBase } from '../serviceRequestBase';
import { Application, ApplicationState } from './application.contractpart';

export class ApplicationQueryRequestBody extends NaniumObject<ApplicationQueryRequestBody> {
	@Type(String) name?: string;
	@Type(String) accountNumber?: string;
	@Type(String) applicationNumber?: string;
	@Type(Date) before?: Date;
	@Type(Date) after?: Date;
	@Type(Array, String) state?: ApplicationState[];
	@Type(String) reviserId?: string;
	@Type(String) withDocument?: string;
	@Type(String) remark?: string;
	@Type(String) paymentState?: 'outstanding' | 'done';
	@Type(String) countryId?: string;

	@Type(Object) projection?: any;
}

@RequestType({
	responseType: Application,
	genericTypes: {TRequestBody: ApplicationQueryRequestBody},
	scope: 'public'
})
export class ApplicationQueryRequest extends ServiceRequestBase<ApplicationQueryRequestBody, Application[]> {
	static serviceName: string = 'EduApplication:application/query';
}
